import { useState } from 'react';
import { Link } from 'react-router-dom';

const CATEGORIES = ['All', 'Orders', 'Shipping', 'Returns', 'Products', 'Account'];

const FAQS = [
  { cat: 'Orders', q: 'How do I place an order?', a: 'Browse our collection, add items to your cart, and proceed to checkout. You\'ll need to create an account or log in, choose a delivery address, select a payment method, and confirm your order.' },
  { cat: 'Orders', q: 'Can I modify or cancel my order after placing it?', a: 'Orders can be modified or cancelled within 1 hour of placement. After that, the order goes into processing. Please contact us immediately at support@bhadralok.com if you need to make changes.' },
  { cat: 'Orders', q: 'What payment methods do you accept?', a: 'We accept UPI (GPay, PhonePe, Paytm, BHIM), all major credit and debit cards (Visa, Mastercard, RuPay, Amex), Net Banking, and Cash on Delivery (available in select cities).' },
  { cat: 'Shipping', q: 'How long does delivery take?', a: 'Standard shipping takes 5–7 business days. Express shipping (available at checkout) takes 2–3 business days. Same-day delivery is available in Kolkata for orders placed before 12 noon.' },
  { cat: 'Shipping', q: 'Is shipping free?', a: 'Yes! Shipping is FREE on all orders above ₹999. Orders below ₹999 attract a flat shipping fee of ₹99. Express shipping is charged at ₹149 regardless of order value.' },
  { cat: 'Shipping', q: 'Do you ship internationally?', a: 'We currently ship to 50+ countries including USA, UK, Canada, Australia, Singapore, and UAE. International shipping typically takes 10–15 business days. Customs duties and taxes are the buyer\'s responsibility.' },
  { cat: 'Shipping', q: 'How can I track my order?', a: 'Once your order is shipped, you\'ll receive a tracking link via email and SMS. You can also track your order from the "My Orders" section in your account dashboard.' },
  { cat: 'Returns', q: 'What is your return policy?', a: 'We offer a 15-day easy return policy from the date of delivery. Items must be unworn, unwashed, and in original packaging with all tags intact. Sale items and customized products are not eligible for returns.' },
  { cat: 'Returns', q: 'How do I initiate a return?', a: 'Log in to your account, go to My Orders, select the item you want to return, and click "Return". Our team will arrange a pickup within 2–3 business days. Refunds are processed within 5–7 business days after we receive the item.' },
  { cat: 'Returns', q: 'Can I exchange an item for a different size?', a: 'Yes, exchanges are accepted within 15 days. We recommend consulting our Size Guide before purchasing. Exchanges are subject to availability. If the size is unavailable, a full refund will be issued.' },
  { cat: 'Products', q: 'How do I find the right size?', a: 'Refer to our detailed Size Guide on each product page. We provide measurements in cm and inches, along with fit tips. When in doubt, size up — Bengali draping styles look great in relaxed fits.' },
  { cat: 'Products', q: 'Are the colors accurate in the photos?', a: 'We make every effort to represent colors accurately. However, colors may vary slightly depending on your screen calibration. If you\'re ordering a gift or have specific color requirements, please reach out.' },
  { cat: 'Products', q: 'How do I care for my Bhadralok garments?', a: 'Most of our garments should be hand-washed in cold water or dry-cleaned. Avoid wringing. Tumble dry on low or air dry in shade. Detailed care instructions are printed on the garment labels.' },
  { cat: 'Account', q: 'How do I create an account?', a: 'Click "Sign In" in the top navigation, then select "Create an account". Fill in your name, email, and password. You\'ll receive a verification email — click the link to activate your account.' },
  { cat: 'Account', q: 'I forgot my password. What do I do?', a: 'On the login page, click "Forgot Password?" and enter your registered email. You\'ll receive a password reset link within a few minutes. Check your spam folder if you don\'t see it.' },
];

export default function FAQs() {
  const [activeCat, setActiveCat] = useState('All');
  const [openIdx, setOpenIdx]     = useState(null);
  const [search, setSearch]       = useState('');

  const filtered = FAQS.filter((f) => {
    const matchCat  = activeCat === 'All' || f.cat === activeCat;
    const matchSearch = !search || f.q.toLowerCase().includes(search.toLowerCase()) || f.a.toLowerCase().includes(search.toLowerCase());
    return matchCat && matchSearch;
  });

  return (
    <div className="page-top">
      {/* Hero */}
      <div style={S.hero}>
        <div style={S.heroBg}>FAQs</div>
        <div style={S.heroContent}>
          <p className="sec-label" style={{ color: 'var(--gold)', marginBottom: '10px' }}>Frequently Asked Questions</p>
          <h1 style={S.heroTitle}>HOW CAN WE HELP?</h1>
          <div style={S.searchWrap}>
            <span style={S.searchIcon}>🔍</span>
            <input style={S.searchInp} placeholder="Search questions..." value={search} onChange={(e) => setSearch(e.target.value)} />
          </div>
        </div>
      </div>

      {/* Layout */}
      <div style={S.layout}>
        {/* Main */}
        <div>
          {/* Categories */}
          <div style={S.catRow}>
            {CATEGORIES.map((c) => (
              <button key={c} style={{ ...S.catBtn, background: activeCat === c ? 'var(--black)' : '#fff', color: activeCat === c ? '#fff' : 'var(--black)', border: `1.5px solid ${activeCat === c ? 'var(--black)' : 'var(--border)'}` }}
                onClick={() => setActiveCat(c)}>{c}</button>
            ))}
          </div>

          {/* Accordion */}
          <div style={S.faqList}>
            {filtered.length === 0 && (
              <div style={{ padding: '40px', textAlign: 'center', color: '#888' }}>
                <p style={{ fontSize: '24px', marginBottom: '8px' }}>🤷</p>
                <p style={{ fontWeight: 600 }}>No results found for "{search}"</p>
                <p style={{ fontSize: '12px', color: '#aaa' }}>Try a different keyword or browse all categories</p>
              </div>
            )}
            {filtered.map((f, i) => (
              <div key={i} style={{ ...S.faqItem, borderColor: openIdx === i ? 'var(--red)' : 'var(--border)' }}>
                <div style={{ ...S.faqQ, background: openIdx === i ? '#fff9f9' : '#fff' }} onClick={() => setOpenIdx(openIdx === i ? null : i)}>
                  <div>
                    <span style={S.faqCatTag}>{f.cat}</span>
                    <p style={{ ...S.faqQText, color: openIdx === i ? 'var(--red)' : 'var(--black)' }}>{f.q}</p>
                  </div>
                  <span style={{ ...S.faqArr, transform: openIdx === i ? 'rotate(180deg)' : 'none', color: openIdx === i ? 'var(--red)' : '#aaa' }}>▼</span>
                </div>
                {openIdx === i && (
                  <div style={S.faqAns}>
                    <p>{f.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Sidebar */}
        <aside style={S.sidebar}>
          {/* Quick Links */}
          <div style={S.sideCard}>
            <p style={S.sideTitle}>QUICK LINKS</p>
            {[
              { to: '/track-order', icon: '📦', label: 'Track Your Order' },
              { to: '/returns',     icon: '↩️', label: 'Returns & Exchange' },
              { to: '/size-guide',  icon: '📏', label: 'Size Guide' },
              { to: '/contact',     icon: '💬', label: 'Contact Support' },
            ].map((l) => (
              <Link key={l.to} to={l.to} style={S.sideLink}>
                <span style={{ marginRight: '8px' }}>{l.icon}</span>{l.label}
              </Link>
            ))}
          </div>

          {/* Still stuck */}
          <div style={S.helpCard}>
            <p style={{ fontFamily: 'var(--font-display)', fontSize: '16px', letterSpacing: '2px', marginBottom: '8px', color: '#fff' }}>STILL NEED HELP?</p>
            <p style={{ fontSize: '12px', color: 'rgba(255,255,255,.5)', lineHeight: 1.7, marginBottom: '16px' }}>Our support team is available Mon–Sat, 10am–7pm IST.</p>
            <Link to="/contact" style={S.helpCta}>Chat With Us →</Link>
          </div>

          {/* Stats */}
          <div style={S.statsCard}>
            {[['99%','Customer Satisfaction'],['< 24h','Average Response Time'],['15 Days','Easy Returns']].map(([v, l]) => (
              <div key={l} style={S.statItem}>
                <p style={{ fontFamily: 'var(--font-display)', fontSize: '20px', letterSpacing: '1px', color: 'var(--red)', margin: 0 }}>{v}</p>
                <p style={{ fontSize: '11px', color: '#888', fontWeight: 700, letterSpacing: '.5px', textTransform: 'uppercase', margin: 0 }}>{l}</p>
              </div>
            ))}
          </div>
        </aside>
      </div>
    </div>
  );
}

const S = {
  hero:        { background: 'var(--black)', padding: '60px 56px 52px', position: 'relative', overflow: 'hidden', borderBottom: '4px solid var(--gold)' },
  heroBg:      { position: 'absolute', right: '-20px', top: '50%', transform: 'translateY(-50%)', fontFamily: 'var(--font-display)', fontSize: 'clamp(80px,15vw,180px)', letterSpacing: '-4px', color: 'rgba(255,255,255,.04)', lineHeight: 1, userSelect: 'none' },
  heroContent: { position: 'relative', zIndex: 1 },
  heroTitle:   { fontFamily: 'var(--font-display)', fontSize: 'clamp(32px,5vw,56px)', letterSpacing: '2px', color: '#fff', lineHeight: 1, marginBottom: '24px' },
  searchWrap:  { position: 'relative', maxWidth: '480px' },
  searchIcon:  { position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', fontSize: '14px' },
  searchInp:   { width: '100%', border: '1.5px solid rgba(255,255,255,.15)', background: 'rgba(255,255,255,.08)', padding: '12px 14px 12px 42px', fontFamily: 'var(--font-body)', fontSize: '14px', color: '#fff', outline: 'none', boxSizing: 'border-box', transition: 'border-color .2s' },
  layout:      { display: 'grid', gridTemplateColumns: '1fr 300px', gap: '24px', padding: '36px 56px 80px' },
  catRow:      { display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '20px' },
  catBtn:      { padding: '7px 16px', fontFamily: 'var(--font-body)', fontSize: '11px', fontWeight: 700, letterSpacing: '1px', textTransform: 'uppercase', cursor: 'pointer', transition: 'all .2s' },
  faqList:     { display: 'flex', flexDirection: 'column', gap: '8px' },
  faqItem:     { border: '1.5px solid', transition: 'border-color .2s', background: '#fff' },
  faqQ:        { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', padding: '16px 18px', cursor: 'pointer', gap: '12px', transition: 'background .2s' },
  faqCatTag:   { fontSize: '9px', fontWeight: 700, letterSpacing: '1.5px', textTransform: 'uppercase', color: '#aaa', display: 'block', marginBottom: '4px' },
  faqQText:    { fontSize: '14px', fontWeight: 600, lineHeight: 1.4, margin: 0, transition: 'color .2s' },
  faqArr:      { fontSize: '10px', transition: 'transform .25s', flexShrink: 0, marginTop: '2px' },
  faqAns:      { padding: '0 18px 16px', fontSize: '13px', color: '#555', lineHeight: 1.8, borderTop: '1px solid var(--border)' },
  sidebar:     { position: 'sticky', top: '120px', display: 'flex', flexDirection: 'column', gap: '14px' },
  sideCard:    { background: '#fff', border: '1px solid var(--border)', padding: '18px' },
  sideTitle:   { fontFamily: 'var(--font-display)', fontSize: '12px', letterSpacing: '2.5px', color: '#888', marginBottom: '12px' },
  sideLink:    { display: 'flex', alignItems: 'center', padding: '9px 0', fontSize: '13px', fontWeight: 600, color: 'var(--black)', textDecoration: 'none', borderBottom: '1px solid var(--border)', transition: 'color .2s' },
  helpCard:    { background: 'var(--black)', padding: '20px', borderLeft: '3px solid var(--red)' },
  helpCta:     { display: 'inline-block', background: 'var(--red)', color: '#fff', padding: '9px 20px', fontSize: '11px', fontWeight: 700, letterSpacing: '1.5px', textTransform: 'uppercase', textDecoration: 'none' },
  statsCard:   { background: '#fff', border: '1px solid var(--border)', padding: '18px', display: 'flex', flexDirection: 'column', gap: '14px' },
  statItem:    { display: 'flex', flexDirection: 'column', gap: '2px', padding: '12px 0', borderBottom: '1px solid var(--border)' },
};
